module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image-h"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0013-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "h3",
    attrs: {
      "id": "lev178"
    }
  }, [_vm._v("THE COMMON CART HORSE.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("IS inferior to the Black Horse both in size and strength: his form is heavy, his motions slow, and his aspect without sprightliness: he is nevertheless extremely useful, and is employed in the business of agriculture and other domestic concerns.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0013-02.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-88f4db14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780226044859_14_ch6.vue
// module id = 93
// module chunks = 0